export default "__VITE_ASSET__7d_BC3Te__"